<template>
  <div class="searchbox">
    <input
      type="text"
      placeholder="Search"
      @keyup="updateTerm"
      :value="search_term"
    />
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
    >
      <g
        id="icons-small-search"
        serif:id="icons/small/search"
        transform="matrix(1,0,0,1,-2,-2)"
      >
        <path
          id="Combined-Shape"
          d="M16.581,15.549L21.677,20.601C21.976,20.896 22.22,21.133 21.683,21.677C21.146,22.22 20.907,21.978 20.608,21.682L15.502,16.621C14.076,17.798 12.247,18.506 10.253,18.506C5.696,18.506 2.003,14.812 2.003,10.256C2.003,5.7 5.696,2.006 10.253,2.006C14.809,2.006 18.503,5.7 18.503,10.256C18.503,12.271 17.781,14.117 16.581,15.549ZM10.253,17.006C13.981,17.006 17.003,13.984 17.003,10.256C17.003,6.528 13.981,3.506 10.253,3.506C6.525,3.506 3.503,6.528 3.503,10.256C3.503,13.984 6.525,17.006 10.253,17.006Z"
        />
      </g>
    </svg>

    <img
      @click="clearSearch()"
      src="~@/assets/icons/clear.svg"
      class="clear"
      :class="{ visible: search_term }"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    onChange: Function,
  },
  data() {
    return {
      debounce_timer: null,
    };
  },
  computed: {
    search_term() {
      return this.$store.getters.search_term;
    },
  },
  watch: {
    search_term() {
      this.debounce();
    },
  },
  methods: {
    updateTerm(el) {
      this.$store.dispatch('setSearchTerm', el.target.value);
    },
    debounce() {
      if (this.debounce_timer) {
        clearTimeout(this.debounce_timer);
      }

      this.debounce_timer = setTimeout(() => {
        this.debounce_timer = null;
        this.onChange(this.search_term);
      }, 350);
    },
    clearSearch() {
      this.$store.dispatch('setSearchTerm', '');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.searchbox {
  position: relative;
}

input {
  background: transparent;
  border: none;
  border-bottom: 1px solid #c6d0db;
  outline: none;
  padding-left: 34px;
  padding-right: 26px;
  transition: border 0.3s;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  width: 275px;
  color: $light-text-color;

  &:focus,
  &:active {
    border-bottom: 1px solid $light-text-color;
  }
}

svg {
  position: absolute;
  top: 10px;
  left: 2px;
  width: 20px;
  height: 20px;

  path {
    fill: #c6d0db;
    transition: fill 0.3s;
  }
}

input:focus ~ svg,
input:active ~ svg {
  path {
    fill: $light-text-color;
  }
}

.clear {
  position: absolute;
  top: calc(50% - 13px);
  left: -9999999px;
  cursor: pointer;
  z-index: 5;
  width: 26px;
  padding: 5px;

  &.visible {
    right: -2px;
    left: auto;
  }
}
</style>
